import React, { useEffect, useState } from 'react';
import { Modal, Radio, Space } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useStandTypeStore from '../store/standTypeStore';

interface Props {
  open: boolean;
  loading?: boolean;
  title?: React.ReactNode;
  onConfirm: (standType: string) => void;
  onCancel: () => void;
}

const StandTypeSelectModal: React.FC<Props> = ({ open, loading, title, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const { items: standTypes, fetchItems: fetchStandTypes } = useStandTypeStore();
  const [selectedType, setSelectedType] = useState<string>('all');

  useEffect(() => {
    fetchStandTypes();
  }, [fetchStandTypes]);

  useEffect(() => {
    if (open) setSelectedType('all');
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={title ?? <><FilePdfOutlined style={{ marginRight: 8, color: '#1677ff' }} />{t('events.selectStandType')}</>}
      onOk={() => onConfirm(selectedType)}
      okText={t('general.download')}
      okButtonProps={{ loading, icon: <FilePdfOutlined /> }}
      cancelText={t('general.cancel')}
      width={420}
      destroyOnClose
    >
      <div style={{ padding: '8px 0' }}>
        <Radio.Group value={selectedType} onChange={e => setSelectedType(e.target.value)}>
          <Space direction="vertical">
            <Radio value="all">{t('stand.all')}</Radio>
            {standTypes.map(st => (
              <Radio key={st.id} value={st.id}>{st.name}</Radio>
            ))}
          </Space>
        </Radio.Group>
      </div>
    </Modal>
  );
};

export default StandTypeSelectModal;
